export const DEFAULT_SCREEN0_LANGUAGE = "en" as const;
export const SCREEN0_LANGUAGE_CODES = ["it", "en", "fr", "es", "de"] as const;

export type Screen0LanguageCode = (typeof SCREEN0_LANGUAGE_CODES)[number];

type Screen0LanguageDefinition = {
  code: Screen0LanguageCode;
  intlLocale: string;
  label: string;
};

const SCREEN0_LANGUAGE_DEFINITIONS: Record<
  Screen0LanguageCode,
  Screen0LanguageDefinition
> = {
  it: {
    code: "it",
    intlLocale: "it-IT",
    label: "Italiano",
  },
  en: {
    code: "en",
    intlLocale: "en-US",
    label: "English",
  },
  fr: {
    code: "fr",
    intlLocale: "fr-FR",
    label: "Français",
  },
  es: {
    code: "es",
    intlLocale: "es-ES",
    label: "Español",
  },
  de: {
    code: "de",
    intlLocale: "de-DE",
    label: "Deutsch",
  },
};

export function getNormalizedLanguageTag(languageTag?: string | null) {
  if (!languageTag) {
    return null;
  }

  return languageTag.trim().toLowerCase().replace(/_/g, "-") || null;
}

export function getLanguageBaseCode(languageTag?: string | null) {
  const normalizedTag = getNormalizedLanguageTag(languageTag);

  if (!normalizedTag) {
    return null;
  }

  return normalizedTag.split("-")[0] ?? null;
}

export function isSupportedScreen0Language(languageTag?: string | null) {
  const baseLanguage = getLanguageBaseCode(languageTag);

  return SCREEN0_LANGUAGE_CODES.includes(baseLanguage as Screen0LanguageCode);
}

export function resolveScreen0LanguageCode(
  languageTag?: string | null,
): Screen0LanguageCode {
  const baseLanguage = getLanguageBaseCode(languageTag);

  if (
    SCREEN0_LANGUAGE_CODES.includes(baseLanguage as Screen0LanguageCode)
  ) {
    return baseLanguage as Screen0LanguageCode;
  }

  return DEFAULT_SCREEN0_LANGUAGE;
}

export function getScreen0LanguageDefinition(languageCode: Screen0LanguageCode) {
  return SCREEN0_LANGUAGE_DEFINITIONS[languageCode];
}

export function getScreen0LanguageLabel(languageCode: Screen0LanguageCode) {
  return SCREEN0_LANGUAGE_DEFINITIONS[languageCode].label;
}

export function getScreen0IntlLocale(languageCode: Screen0LanguageCode) {
  return SCREEN0_LANGUAGE_DEFINITIONS[languageCode].intlLocale;
}
